import { gql } from '@apollo/client';

const GET_ASSIGNMENTS = gql`
  query assignmentList($where: AssignmentListWhereInput!) {
    assignmentList(where: $where) {
      instructions {
        assignmentSelection {
          id
          src
          description
          vtt
        }
        activitySelection {
          id
          src
          description
          vtt
        }
      }
      assignments {
        character {
          character
          id
        }
        assignmentActivities {
          activity {
            activityType {
              name
              required
            }
            id
            title
          }
          attempts {
            id
            status
          }
          id
        }
        characterId
        id
        status
        title
      }
    }
  }
`;

export default GET_ASSIGNMENTS;
